import React from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import TextField from "@material-ui/core/TextField";
import FormGroup from "@material-ui/core/FormGroup";
import {DatePicker} from "material-ui-pickers";
import Divider from "@material-ui/core/Divider";
import {connect} from "react-redux";
import {getValueHash, isObjectEquals} from "../../../common/utils/array";
import moment from "moment";
import {getMessage, isDate} from "../../../common/utils/validation";
import {
    getKeiyakuKigyou,
    getButsuryuBoten,
    getMaker, setEntryDetailState
} from "../../../actions";

const styles = theme => ({
    root: {
        width: '100%',
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    formGroups:{
        display: 'flex',
        alignItems: 'flex-start',
        margin: '0 0 5px 0',
    },
    datePicker : {
        marginTop : '-10px',
        width:'150px'
    },
    fromTo : {
        padding: '0 15px',
        fontSize: '1.5rem',
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
    },
    expands : {
        boxShadow:'initial'
    },
    halfDivider:{
        width:30
    },
    halfTextArea:{
        flexBasis:2,
        flexGrow: 2,
    },
    quadTextArea:{
        flexBasis:1,
        flexGrow: 1,
    },
    divider:{
        marginTop:15,
        marginBottom:15
    },
    selectHelperText:{
        color:"#F44336",
        fontSize:'0.75rem',
        marginTop:8,
        minHeight:'1em',
        fontFamily:'"Roboto", "Helvetica", "Arial", sans-serif',
        lineHeight:'1em'
    },
    cdTextWrapper:{
        display:'flex',
    },
    cdNameText:{
        flexGrow:4,
        flexBasis:4,
        marginLeft:10
    }
});

const requireField = [
    "DataTeikyoumotoCD",
    "ButsuryuBotenCD",
    "MakerCD",
    "DenpyoNO",
    "NohinYoteiYMD",
    "DenpyoYMD"
];

class innerForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataSource:getValueHash(props.dataSource),
            errors: {},
            defaultValue:''
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const {settings,dispatch} = this.props;
        let {dataSource} = this.state;
        let errors = getValueHash(this.state.errors);
        let isUpdate = false;

        if(settings.isGetKeiyakuKigyou){
            dispatch(setEntryDetailState({
                isGetKeiyakuKigyou:false
            }))
            if(settings.keiyakukigyou === null){
                errors["DataTeikyoumotoCD"] = getMessage("nocode");
                dataSource["DataTeikyoumotoName"] = "";
            }
            else{
                if("DataTeikyoumotoCD" in errors) delete errors["DataTeikyoumotoCD"];
                dataSource["DataTeikyoumotoName"] = settings.keiyakukigyou.KeiyakuKigyouName;
            }
            isUpdate = true;
        }
        if(settings.isGetMaker){
            dispatch(setEntryDetailState({
                isGetMaker:false
            }))
            if(settings.maker === null){
                errors["MakerCD"] = getMessage("nocode");
                dataSource["MakerName"] = "";
            }
            else{
                if("MakerCD" in errors) delete errors["MakerCD"];
                dataSource["MakerName"] = settings.maker.JigyoushaName;
            }
            isUpdate = true;

        }
        if(settings.isGetButsuryuBoten){
            dispatch(setEntryDetailState({
                isGetButsuryuBoten:false
            }))
            if(settings.butsuryuboten === null){
                errors["ButsuryuBotenCD"] = getMessage("nocode");
                dataSource["ButsuryuBotenName"] = "";
            }
            else{
                if("ButsuryuBotenCD" in errors) delete errors["ButsuryuBotenCD"];
                dataSource["ButsuryuBotenName"] = settings.butsuryuboten.JigyoushaName;
            }
            isUpdate = true;
        }


        if(isUpdate){
            this.setState({
                dataSource,
                errors
            });
            if(this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource,errors);
        }


    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(!isObjectEquals(this.state.dataSource,nextProps.dataSource)){
            const dataSource = getValueHash(nextProps.dataSource);
            const errors = this.errorChecks(nextProps.dataSource);
            this.setState({
                dataSource,
                errors
            });
            if(nextProps.afterChangeFunc) nextProps.afterChangeFunc(dataSource,errors);
        }

    }

    setValues = (key, data) =>{
        if(Object.prototype.toString.call(data) !== '[object Object]') return "";
        if(!(key in data)) return "";
        if(data[key] === null) return "";

        return String(data[key]);
    }

    setDateValues = (key,data) =>{
        if(Object.prototype.toString.call(data) !== '[object Object]') return null;
        if(!(key in data)) return null;
        if(data[key] === null) return null;
        return new moment(data[key]);

    }

    isError = (key, errors) =>{
        return Boolean(key in errors && errors[key]);
    }
    getErrorText = (key,errors)=>{
        if(!(key in errors)) return "";
        if(errors[key] === null || errors[key] === "null" || errors[key] === undefined) return "";
        return errors[key];
    }
    handleChangeText = (event) =>{
        let {dataSource} = this.state;
        dataSource[event.target.name] = event.target.value;
        const errors = this.errorChecks(dataSource,event.target.name);
        this.setState({
            dataSource,
            errors
        });
        if(this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource,errors);
    }


    handleChangeDate = (date,name) =>{
        let {dataSource, errors} = this.state;
        dataSource[name] = moment(date).format('YYYY-MM-DD');
        if (name in errors) delete errors[name];
        this.setState({
            dataSource,
            errors
        });
        if(this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource,errors);

    };
    handleDateInputChange = (event) =>{
        let {dataSource} = this.state;
        let errors = getValueHash(this.state.errors);
        const column = event.target.name;
        const date = event.target.value;

        if(column in errors) delete errors[column];
        if(!isDate(date)){
            errors[column] = getMessage("dateFormat");
        }
        else{
            if(date === ""){
                dataSource[column] = null;
                if(requireField.indexOf(column) >= 0){
                    errors[column] = getMessage("required");
                }
            }
            else{
                dataSource[column] = moment(date).format('YYYY-MM-DD');
            }


        }
        this.setState({
            dataSource,
            errors
        });
        if(this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource,errors);


    };


    errorChecks = (data,key) =>{
        let checkColumn = [];
        if(key === undefined){
            Object.keys(data).forEach((column)=>{
                checkColumn.push(column);
            });
        }
        else{
            checkColumn.push(key);
        }
        let errors = getValueHash(this.state.errors);
        checkColumn.forEach((column)=>{
            if(column in errors) delete errors[column];
            switch(column){
                case "DenpyoYMD":
                case "NohinYoteiYMD":
                    if(this.setValues(column,data) === ""){
                        errors[column] = getMessage("required");
                        break;
                    }
                case "ShukkaYoteiYMD":
                case "HacchuYMD":
                    if(!isDate(this.setValues(column,data))){
                        errors[column] = getMessage("dateFormat");
                    }
                    break;
                default:
                    //requireCheck
                    if(requireField.indexOf(column) >= 0 && this.setValues(column,data) === ""){
                        errors[column] = getMessage("required");
                    }
            }
        });

        return errors;
    }



    handleBlurKeiyakuKigyou = (event) =>{
        let {dataSource,defaultValue,errors} = this.state;
        const value = event.target.value;

        if(value && (value !== defaultValue)){
            this.props.dispatch(getKeiyakuKigyou({
                KeiyakuKigyouCD : value,
                IsIncludeDelete : 0
            }));
        }
        if(!value && value !== defaultValue){
            dataSource["DataTeikyoumotoName"] = "";
            this.setState({
                dataSource
            })
            if(this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource,errors);
        }
    }
    handleBlurButsuryuBoten = (event) =>{
        let {dataSource,defaultValue,errors} = this.state;
        const value = event.target.value;
        if(value && value !== defaultValue){
            this.props.dispatch(getButsuryuBoten({
                ButsuryuBotenCD : value,
                IsIncludeDelete : 0
            }));
        }
        if(!value && value !== defaultValue){
            dataSource["ButsuryuBotenName"] = "";
            this.setState({
                dataSource
            })
            if(this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource,errors);
        }
    }
    handleBlurMaker = (event) =>{
        let {dataSource,defaultValue,errors} = this.state;
        const value = event.target.value;
        if(value && value !== defaultValue){
            this.props.dispatch(getMaker({
                MakerCD : value,
                IsIncludeDelete : 0
            }));
        }
        if(!value && value !== defaultValue){
            dataSource["MakerName"] = "";
            this.setState({
                dataSource
            })
            if(this.props.afterChangeFunc) this.props.afterChangeFunc(dataSource,errors);
        }

    }
    handleOnFocus = (event) =>{
        this.setState({
            defaultValue : event.target.value
        })
    }

    render () {
        const {classes, allDisabled} = this.props;
        const {dataSource, errors} = this.state;


        return (
            <div className={classes.root}>
                <FormGroup row className={classes.formGroups}>
                    <div className={classNames(classes.halfTextArea,classes.cdTextWrapper)}>
                        <TextField
                            label="データ提供元"
                            placeholder="データ提供元"
                            value={this.setValues("DataTeikyoumotoCD",dataSource)}
                            className={classes.halfTextArea}
                            onChange={this.handleChangeText}
                            onBlur={this.handleBlurKeiyakuKigyou}
                            onFocus={this.handleOnFocus}
                            name="DataTeikyoumotoCD"
                            disabled={allDisabled}
                            error={this.isError("DataTeikyoumotoCD",errors)}
                            helperText={this.getErrorText("DataTeikyoumotoCD",errors)}
                            inputProps={{
                                maxLength:13
                            }}
                        />
                        <TextField
                            value={this.setValues("DataTeikyoumotoName",dataSource)}
                            name="DataTeikyoumotoName"
                            label={" "}
                            disabled={true}
                            className={classes.cdNameText}
                        />
                    </div>
                    <div className={classes.halfDivider} />
                    <div className={classNames(classes.halfTextArea,classes.cdTextWrapper)}>
                        <TextField
                            label="物流母店"
                            placeholder="物流母店"
                            value={this.setValues("ButsuryuBotenCD",dataSource)}
                            className={classes.halfTextArea}
                            onChange={this.handleChangeText}
                            onBlur={this.handleBlurButsuryuBoten}
                            onFocus={this.handleOnFocus}
                            name="ButsuryuBotenCD"
                            disabled={allDisabled}
                            error={this.isError("ButsuryuBotenCD",errors)}
                            helperText={this.getErrorText("ButsuryuBotenCD",errors)}
                            inputProps={{
                                maxLength:10
                            }}
                        />
                        <TextField
                            value={this.setValues("ButsuryuBotenName",dataSource)}
                            name="ButsuryuBotenName"
                            disabled={true}
                            label={" "}
                            className={classes.cdNameText}
                        />
                    </div>
                </FormGroup>
                <FormGroup row className={classes.formGroups}>
                    <div className={classNames(classes.halfTextArea,classes.cdTextWrapper)}>
                        <TextField
                            label="メーカー"
                            placeholder="メーカー"
                            value={this.setValues("MakerCD",dataSource)}
                            className={classes.halfTextArea}
                            onChange={this.handleChangeText}
                            onBlur={this.handleBlurMaker}
                            onFocus={this.handleOnFocus}
                            name="MakerCD"
                            disabled={allDisabled}
                            error={this.isError("MakerCD",errors)}
                            helperText={this.getErrorText("MakerCD",errors)}
                            inputProps={{
                                maxLength:10
                            }}
                        />
                        <TextField
                            value={this.setValues("MakerName",dataSource)}
                            name="MakerName"
                            disabled={true}
                            label={" "}
                            className={classes.cdNameText}
                        />
                    </div>
                    <div className={classes.halfDivider} />
                    <TextField
                        label="荷主名称"
                        placeholder="荷主名称"
                        value={this.setValues("NinushiName",dataSource)}
                        className={classes.halfTextArea}
                        onChange={this.handleChangeText}
                        name="NinushiName"
                        disabled={allDisabled}
                        error={this.isError("NinushiName",errors)}
                        helperText={this.getErrorText("NinushiName",errors)}
                        inputProps={{
                            maxLength:90
                        }}
                    />
                </FormGroup>
                <FormGroup row className={classes.formGroups}>
                    <TextField
                        label="荷主住所"
                        placeholder="荷主住所"
                        value={this.setValues("NinushiAddress",dataSource)}
                        className={classes.halfTextArea}
                        onChange={this.handleChangeText}
                        name="NinushiAddress"
                        disabled={allDisabled}
                        error={this.isError("NinushiAddress",errors)}
                        helperText={this.getErrorText("NinushiAddress",errors)}
                        inputProps={{
                            maxLength:120
                        }}
                    />
                </FormGroup>
                <FormGroup row className={classes.formGroups}>
                    <TextField
                        label="荷主電話番号"
                        placeholder="荷主電話番号"
                        value={this.setValues("NinushiTel",dataSource)}
                        className={classes.quadTextArea}
                        onChange={this.handleChangeText}
                        name="NinushiTel"
                        disabled={allDisabled}
                        error={this.isError("NinushiTel",errors)}
                        helperText={this.getErrorText("NinushiTel",errors)}
                        inputProps={{
                            maxLength:15
                        }}
                    />
                    <div className={classes.halfDivider} />
                    <div className={classes.halfTextArea} />
                    <div className={classes.halfDivider} />
                    <div className={classes.halfTextArea} />
                </FormGroup>
                <FormGroup row className={classes.formGroups}>
                    <TextField
                        label="問合先名称"
                        placeholder="問合先名称"
                        value={this.setValues("ToiawasesakiName",dataSource)}
                        className={classes.halfTextArea}
                        onChange={this.handleChangeText}
                        name="ToiawasesakiName"
                        disabled={allDisabled}
                        error={this.isError("ToiawasesakiName",errors)}
                        helperText={this.getErrorText("ToiawasesakiName",errors)}
                        inputProps={{
                            maxLength:80
                        }}
                    />
                    <div className={classes.halfDivider} />
                    <TextField
                        label="問合先電話番号"
                        placeholder="問合先電話番号"
                        value={this.setValues("ToiawasesakiTel",dataSource)}
                        className={classes.quadTextArea}
                        onChange={this.handleChangeText}
                        name="ToiawasesakiTel"
                        disabled={allDisabled}
                        error={this.isError("ToiawasesakiTel",errors)}
                        helperText={this.getErrorText("ToiawasesakiTel",errors)}
                        inputProps={{
                            maxLength:15
                        }}
                    />
                </FormGroup>
                <FormGroup row className={classes.formGroups}>
                    <TextField
                        label="伝票番号"
                        placeholder="伝票番号"
                        value={this.setValues("DenpyoNO",dataSource)}
                        className={classes.quadTextArea}
                        onChange={this.handleChangeText}
                        name="DenpyoNO"
                        disabled={allDisabled}
                        error={this.isError("DenpyoNO",errors)}
                        helperText={this.getErrorText("DenpyoNO",errors)}
                        inputProps={{
                            maxLength:20
                        }}
                    />
                    <div className={classes.halfDivider} />
                    <div className={classes.halfTextArea} />
                    <div className={classes.halfDivider} />
                    <div className={classes.halfTextArea} />
                </FormGroup>
                <Divider className={classes.divider} />
                <FormGroup row className={classes.formGroups}>
                    <DatePicker
                        keyboard
                        label="出荷日"
                        value={this.setDateValues("ShukkaYoteiYMD",dataSource)}
                        onChange={(date)=>this.handleChangeDate(date, "ShukkaYoteiYMD")}
                        onInputChange={this.handleDateInputChange}
                        format="YYYY/MM/DD"
                        className={classes.datePicker}
                        name="ShukkaYoteiYMD"
                        disabled={allDisabled}
                        error={this.isError("ShukkaYoteiYMD",errors)}
                        helperText={this.getErrorText("ShukkaYoteiYMD",errors)}
                        cancelLabel={"キャンセル"}
                    />
                    <div className={classes.halfDivider} />
                    <DatePicker
                        keyboard
                        label="納品日"
                        value={this.setDateValues("NohinYoteiYMD",dataSource)}
                        onChange={(date)=>this.handleChangeDate(date, "NohinYoteiYMD")}
                        onInputChange={this.handleDateInputChange}
                        format="YYYY/MM/DD"
                        className={classes.datePicker}
                        name="NohinYoteiYMD"
                        disabled={allDisabled}
                        error={this.isError("NohinYoteiYMD",errors)}
                        helperText={this.getErrorText("NohinYoteiYMD",errors)}
                        cancelLabel={"キャンセル"}
                    />
                    <div className={classes.halfDivider} />
                    <DatePicker
                        keyboard
                        label="伝票日付"
                        value={this.setDateValues("DenpyoYMD",dataSource)}
                        onChange={(date)=>this.handleChangeDate(date, "DenpyoYMD")}
                        onInputChange={this.handleDateInputChange}
                        format="YYYY/MM/DD"
                        className={classes.datePicker}
                        name="DenpyoYMD"
                        disabled={allDisabled}
                        error={this.isError("DenpyoYMD",errors)}
                        helperText={this.getErrorText("DenpyoYMD",errors)}
                        cancelLabel={"キャンセル"}
                    />
                    <div className={classes.halfDivider} />
                    <DatePicker
                        keyboard
                        label="発注日"
                        value={this.setDateValues("HacchuYMD",dataSource)}
                        onChange={(date)=>this.handleChangeDate(date, "HacchuYMD")}
                        onInputChange={this.handleDateInputChange}
                        format="YYYY/MM/DD"
                        className={classes.datePicker}
                        name="HacchuYMD"
                        disabled={allDisabled}
                        error={this.isError("HacchuYMD",errors)}
                        helperText={this.getErrorText("HacchuYMD",errors)}
                        cancelLabel={"キャンセル"}
                    />
                </FormGroup>
                <FormGroup row className={classes.formGroups}>
                    <TextField
                        label="お届け先CD"
                        placeholder="お届け先CD"
                        value={this.setValues("NohinsakiCD",dataSource)}
                        className={classes.quadTextArea}
                        onChange={this.handleChangeText}
                        name="NohinsakiCD"
                        disabled={allDisabled}
                        error={this.isError("NohinsakiCD",errors)}
                        helperText={this.getErrorText("NohinsakiCD",errors)}
                        inputProps={{
                            maxLength:20
                        }}
                    />
                    <div className={classes.halfDivider} />
                    <TextField
                        label="お届け先名称"
                        placeholder="お届け先名称"
                        value={this.setValues("OtodokesakiName",dataSource)}
                        className={classes.halfTextArea}
                        onChange={this.handleChangeText}
                        name="OtodokesakiName"
                        disabled={allDisabled}
                        error={this.isError("OtodokesakiName",errors)}
                        helperText={this.getErrorText("OtodokesakiName",errors)}
                        inputProps={{
                            maxLength:120
                        }}
                    />
                </FormGroup>
                <FormGroup row className={classes.formGroups}>
                    <TextField
                        label="お届け先住所"
                        placeholder="お届け先住所"
                        value={this.setValues("OtodokesakiAddress",dataSource)}
                        className={classes.halfTextArea}
                        onChange={this.handleChangeText}
                        name="OtodokesakiAddress"
                        disabled={allDisabled}
                        error={this.isError("OtodokesakiAddress",errors)}
                        helperText={this.getErrorText("OtodokesakiAddress",errors)}
                        inputProps={{
                            maxLength:120
                        }}
                    />
                </FormGroup>
                <FormGroup row className={classes.formGroups}>
                    <TextField
                        label="帳合先CD"
                        placeholder="帳合先CD"
                        value={this.setValues("ChoaisakiCD",dataSource)}
                        className={classes.quadTextArea}
                        onChange={this.handleChangeText}
                        name="ChoaisakiCD"
                        disabled={allDisabled}
                        error={this.isError("ChoaisakiCD",errors)}
                        helperText={this.getErrorText("ChoaisakiCD",errors)}
                        inputProps={{
                            maxLength:20
                        }}
                    />
                    <div className={classes.halfDivider} />
                    <TextField
                        label="帳合先名称"
                        placeholder="帳合先名称"
                        value={this.setValues("ChoaisakiName",dataSource)}
                        className={classes.halfTextArea}
                        onChange={this.handleChangeText}
                        name="ChoaisakiName"
                        disabled={allDisabled}
                        error={this.isError("ChoaisakiName",errors)}
                        helperText={this.getErrorText("ChoaisakiName",errors)}
                        inputProps={{
                            maxLength:80
                        }}
                    />
                </FormGroup>
                <FormGroup row className={classes.formGroups}>
                    <TextField
                        label="備考1"
                        placeholder="備考1"
                        value={this.setValues("Biko1",dataSource)}
                        className={classes.halfTextArea}
                        onChange={this.handleChangeText}
                        name="Biko1"
                        disabled={allDisabled}
                        error={this.isError("Biko1",errors)}
                        helperText={this.getErrorText("Biko1",errors)}
                        inputProps={{
                            maxLength:40
                        }}
                    />
                    <div className={classes.halfDivider} />
                    <TextField
                        label="備考2"
                        placeholder="備考2"
                        value={this.setValues("Biko2",dataSource)}
                        className={classes.halfTextArea}
                        onChange={this.handleChangeText}
                        name="Biko2"
                        disabled={allDisabled}
                        error={this.isError("Biko2",errors)}
                        helperText={this.getErrorText("Biko2",errors)}
                        inputProps={{
                            maxLength:40
                        }}
                    />
                </FormGroup>
            </div>
        );
    }
}


innerForm.propTypes = {
    dataSource: PropTypes.object,
    allDisabled:PropTypes.bool,
    afterChangeFunc: PropTypes.func
}

innerForm.defaultProps = {
    dataSource: {},
    allDisabled:false,
}

function mapStateToProps(state) {
    return {
        navigation : state.navigation,
        auth: state.auth,
        settings : state.entryDetailSettings
    };
}
export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(innerForm);



// WEBPACK FOOTER //
// ./src/routes/entry-detail/components/inner-form.js